<template>
	<div v-if="slug" data-component="icon" :class="`${size}`">
		<Icon />
	</div>
</template>

<script setup>
import { defineAsyncComponent } from 'vue'

const props = defineProps({
	slug: { type: [Boolean, String], default: false },
	size: {
		type: String,
		default: 'm',
		validator(value) {
			return ['xxl', 'xl', 'l', 'm', 's', 'xs'].includes(value)
		},
	},
})

const Icon = defineAsyncComponent(async () => import(`~/assets/icons/${props.slug}.svg`))
</script>

<style lang="scss" scoped>
[data-component='icon'] {
	position: relative;

	display: flex;
	align-items: center;
	justify-content: center;

	&.xxl {
		height: rs(32, 32);
		width: rs(32, 32);
	}

	&.xl {
		height: rs(42, 42);
		width: rs(42, 42);
	}

	&.l {
		height: rs(32, 24);
		width: rs(32, 24);
	}

	&.m {
		height: rs(24, 24);
		width: rs(24, 24);
	}

	&.s {
		height: rs(16, 14);
		width: rs(16, 14);
	}

	&.xs {
		height: rs(12, 10);
		width: rs(12, 10);
	}

	:deep(svg) {
		height: 100%;
		width: 100%;
	}

	:deep(svg) {
		path,
		circle,
		line {
			fill: var(--icon-color, #000000);
			stroke: none;
		}
	}
}
</style>
